<div class="">
  <div class="">
    @if (!loading) {
      <div class="payment-cancel-container">
        <div class="cancel-card">
          <div class="cancel-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="currentColor"/>
              <path d="M25 25L55 55M55 25L25 55" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="cancel-title">Payment Cancelled</h2>
          <p class="cancel-message">Your payment was cancelled. No charges were made to your account.</p>
          <div class="action-buttons">
            <button class="btn btn-theme" (click)="retryPayment()">
              Try again
            </button>
            <button class="btn btn-outline" (click)="goToSubscription()">
              View plans
            </button>
            <button class="btn btn-white" (click)="contactSupport()">
              Contact support
            </button>
            <button class="btn btn-dark" (click)="goToDashboard()">
              Go to dashboard
            </button>
          </div>
        </div>
      </div>
    }

    @if (loading) {
      <div class="loading-container">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Processing...</p>
        </div>
      </div>
    }
  </div>
</div>